/* When the user clicks on the button,
toggle between hiding and showing the dropdown content */

export function initDropdown() {
    document.querySelectorAll(".dropbtn").forEach(button => {
        button.addEventListener("click", function (event) {
            event.stopPropagation(); 

            let dropdown = this.nextElementSibling;
            let icon = this.querySelector("i");

            if (dropdown.classList.contains("show")) {
                dropdown.classList.remove("show");
                icon.classList.remove("rotate-270");
                icon.classList.add("rotate-180");
            } else {
                document.querySelectorAll(".dropdown-content").forEach(d => d.classList.remove("show"));
                document.querySelectorAll(".dropbtn i").forEach(i => {
                    i.classList.remove("rotate-270");
                    i.classList.add("rotate-180");
                });

                dropdown.classList.add("show");
                icon.classList.remove("rotate-180");
                icon.classList.add("rotate-270");
            }
        });
    });

    window.addEventListener("click", function () {
        document.querySelectorAll(".dropdown-content").forEach(dropdown => dropdown.classList.remove("show"));
        document.querySelectorAll(".dropbtn i").forEach(icon => {
            icon.classList.remove("rotate-270");
            icon.classList.add("rotate-180");
        });
    });
}